import React from "react";
import { motion } from "framer-motion";
import { Button } from "src/components/ui/Button";

interface EmptyStateProps {
  title: string;
  description?: string;
  svgPath?: string; // Custom SVG path string
  actionText?: string;
  onActionClick?: () => void;
  className?: string;
  svgStrokeColor?: string; // Optional color override
  svgSize?: number; // Optional size (defaults to 48)
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  svgPath,
  actionText,
  onActionClick,
  className = "",
  svgStrokeColor = "#9CA3AF", // Tailwind's gray-400
  svgSize = 48,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className={`flex flex-col items-center text-center px-4 py-12 ${className}`}
    >
      {svgPath && (
        <svg
          className="mb-4"
          width={svgSize}
          height={svgSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke={svgStrokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d={svgPath} />
        </svg>
      )}
      <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
      {description && (
        <p className="mt-2 text-gray-500 max-w-md">{description}</p>
      )}
      {actionText && onActionClick && (
        <div className="mt-6">
          <Button onClick={onActionClick}>{actionText}</Button>
        </div>
      )}
    </motion.div>
  );
}; 